import React from "react";
import { M44MediaViewer } from "../../../M44MediaViewer";
import { MediaViewerComponent } from "../../../MediaViewerComponent/MediaViewerComponent";
export const AnimationSection = ({ animationSrc, animationStateMachines, imageEl, videoUrl, overlayMediaUrl, }) => {
    const mediaOverlay = overlayMediaUrl && (React.createElement(M44MediaViewer, { mediaFileUrl: overlayMediaUrl, addDivWrapper: true, mediaClassname: "HeroBannerHomepageUplift__media-overlay" }));
    if (animationSrc && animationStateMachines) {
        return (React.createElement("div", { className: "HeroBannerHomepageUplift__media HeroBannerHomepageUplift__content__animation-container" },
            React.createElement(MediaViewerComponent, { src: animationSrc, stateMachines: animationStateMachines }),
            mediaOverlay));
    }
    if (imageEl) {
        return (React.createElement("div", { className: "HeroBannerHomepageUplift__media HeroBannerHomepageUplift__image" }, imageEl));
    }
    if (videoUrl) {
        return (React.createElement("div", { className: "HeroBannerHomepageUplift__media HeroBannerHomepageUplift__video" },
            React.createElement(M44MediaViewer, { mediaFileUrl: videoUrl, addDivWrapper: false }),
            mediaOverlay));
    }
    return React.createElement(React.Fragment, null);
};
